import { Outlet } from "react-router-dom";
import PageLayout from "../../layout/page-layout";

export default function SettingsWrapper() {

    return (
        <PageLayout>
            <Outlet />
        </PageLayout>
    );
}